(function(app) {

    app.factory("stateHistory",
        [
            "$state", "$location", "$transitions",
            function($state, $location, $transitions) {

                var history = [];

                function setup() {
                    $transitions.onSuccess({},
                        function (transition) {
                            var to = transition.$to();
                            var current = false;

                            if (history.length >= 1) {
                                current = history.pop();
                            }

                            var params = {};
                            if ($state.params) {
                                params = Object.assign({}, $state.params);
                            }

                            if (current) {
                                if (to.name === current.name) {
                                    history.push({
                                        name: to.name,
                                        params: params
                                    });
                                } else {
                                    history.push(current);
                                    history.push({
                                        name: to.name,
                                        params: params
                                    });
                                }
                            } else {
                                history.push({
                                    name: to.name,
                                    params: params
                                });
                            }
                        });
                }

                function goBack(fallback, fallbackParams) {
                    if (history.length >= 2) {
                        history.pop();
                        var last = history.pop();
                        $state.go(last.name,
                            last.params,
                            {
                                inherit: false,
                                location: true,
                                notify: true,
                                reload: true
                            });
                    }
                    else {
                        if (history.length === 1) {
                            history.pop();
                        }
                        
                        $state.go(fallback,
                            fallbackParams,
                            {
                                inherit: false,
                                location: true,
                                notify: true,
                                reload: true
                            });
                    }
                }

                function setQuery(params) {
                    var current = $state.$current;
                    $location.replace().search(params);
                    $state.transitionTo(current.name,
                        params,
                        {
                            inherit: false,
                            location: "replace",
                            notify: false,
                            reload: false
                        });
                }

                return {
                    history: history,
                    setup: setup,
                    goBack: goBack,
                    setQuery: setQuery
                };
            }
        ]);

})(window.app);